import { useRouter } from 'next/navigation';
import { useLoginLinkTracking } from './useLoginLinkTracking';
import { trackLoginLinkTapped } from '../eventHandlerTracking';
import { useAnalyticsModuleTracking } from '../AnalyticsModuleTracking';

interface LoginLinkHandlerProps {
  cta_copy: string;
}

export const useLoginLinkHandler = ({ cta_copy }: LoginLinkHandlerProps) => {
  const { attributes } = useAnalyticsModuleTracking();
  const lpType = attributes.pageTags?.some(tag => tag.id === 'paid') ? 'paid' : 'organic';
  const loginLinkTracking = useLoginLinkTracking({ cta_copy, lp_type: lpType });
  const router = useRouter();

  const handleLoginClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    loginLinkTracking();
    trackLoginLinkTapped({
      cta_copy,
      lp_type: lpType,
    });

    router.push(e.currentTarget.href);
  };

  return handleLoginClick;
};
